import { createContext } from "react";
// do not set minimumFractionDigits as long as this is used for Integer, too
export const DEFAULT_NUMBER_FORMAT_OPTIONS = {
    maximumFractionDigits: 17, // 17 is maximum here
    useGrouping: true,
};
/**
 * Used by default for attributes of data type Integer
 */
export const DefaultIntegerFormatOptionsContext = createContext(DEFAULT_NUMBER_FORMAT_OPTIONS);
DefaultIntegerFormatOptionsContext.displayName =
    "DefaultIntegerFormatOptionsContext";
/**
 * Used by default for attributes of data type Double
 */
export const DefaultDoubleFormatOptionsContext = createContext(DEFAULT_NUMBER_FORMAT_OPTIONS);
DefaultDoubleFormatOptionsContext.displayName =
    "DefaultDoubleFormatOptionsContext";
//# sourceMappingURL=DefaultNumberFormatOptionsContext.js.map